import { h } from 'preact'
import Icon from '../assets'
import Tooltip from '../ui-components/Tooltip'

export default ({ title } : { title: string }) => {
  if (!title) return
  return <Tooltip trigger={<Icon icon={'question'} height={16} width={16} />} tooltipMessage={title} />
}
